<script lang="tsx">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'JtDetailDrawer',
})
</script>
<!--
 * @Descripttion: 
 * @version: 详情抽屉drawer json配置组件
 * @Author: wlk
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: wlk
 * @LastEditTime: 2024-06-13 09:40:50
-->
<template>
  <Drawer
    v-bind="$attrs"
    :visible="visible"
    destroyOnClose
    :title="title || $lang('详情')"
    @close="cancel"
    :width="width || '40%'"
    placement="right"
  >
    <Form layout="vertical">
      <div v-for="(item, index) in columns" :key="index">
        <div v-if="formatterShow(item.show) !== false">
          <FormGroup v-if="item.group" :title="$lang(item.groupTitle)" />
          <Row :gutter="24" v-if="!item.slot">
            <!-- 默认为6 表示默认一行4列,可根据需求自定义传入 -->
            <Col :span="_.span || 6" v-for="_ in item.childs" :key="_.type" v-show="_.show !== false">
              <div v-if="formatterShow(_.show) !== false">
                <slot v-if="_.slot" :name="_.prop" :value="formState"></slot>
                <FormItem v-else :label="$lang(_.label)">
                  <!-- 渲染图片类型  -->
                  <div class="photo-list" v-if="_.type === 'image'">
                    <!-- 兼容prop属性嵌套 深层级 -->
                    <div
                      v-if="Array.isArray(_.prop) && _.prop.length > 1 && formState[_.prop[0]]"
                      class="photo-list-item"
                    >
                      <!-- 接口返回字段存在 -->
                      <div v-if="formState[_.prop[0]][_.prop[1]]">
                        <!--  如果存在一个字段多张图片的情况 -->
                        <Image
                          v-if="Array.isArray(formState[_.prop[0]][_.prop[1]])"
                          v-for="item in formState[_.prop[0]][_.prop[1]]"
                          :key="item.url"
                          :src="item.url || item"
                        />
                        <!-- 一个字段单张图片的情况 -->
                        <Image v-else :src="formState[_.prop[0]][_.prop[1]]" />
                      </div>
                      <!-- 接口返回字段不存在 -->
                      <div v-else>--</div>
                    </div>

                    <div v-else class="photo-list-item">
                      <div v-if="formState[_.prop]">
                        <Image
                          v-if="Array.isArray(formState[_.prop])"
                          v-for="item in formState[_.prop]"
                          :src="item.url || item"
                          :key="item.url"
                        />
                        <Image v-else :src="formState[_.prop]" />
                      </div>
                      <div v-else>--</div>
                    </div>
                  </div>

                  <!-- 渲染文本类型 -->
                  <div v-else>
                    <!-- customRender自定义渲染内容 -->
                    <div :class="`rendSlot-${_.prop}`" v-if="_.customRender">
                      {{ customRender(_.customRender, _.prop) }}
                    </div>
                    <div v-else>
                      <!-- formatter格式化内容 -->
                      <div v-if="_.formatter">{{ formatter(_, _.prop, _.formatter) }}</div>
                      <div v-else>{{ formState[_.prop] || '--' }}</div>
                    </div>
                  </div>
                </FormItem>
              </div>
            </Col>
          </Row>
        </div>
        <slot v-if="item.slot"></slot>
        <slot name="afterSlot"></slot>
      </div>
    </Form>
    <slot name="footerSlot" :formState="formState" :sticky="props.sticky"></slot>
  </Drawer>
</template>
<script lang="tsx" setup name="JtDetailDrawer">
  import { reactive, render, toRefs, watch } from 'vue'
  import { Drawer, Row, Col, Form, FormItem, Image } from 'ant-design-vue'
  interface IColumunProp {
    label: string
    prop: string
    span?: number
    show?: boolean | Function
    slot?: boolean
    type?: string
    photoList?: Array<{ path: string }>
    formatter?: void
    customRender?: void
  }
  interface IColumuns {
    group: boolean
    groupTitle: string
    childs: Array<IColumunProp>
    slot?: boolean
  }

  interface Props {
    visible: boolean
    title: string
    width: string
    columns: Array<IColumuns>
    params: object
    ajaxUrl: Function
    // 底部按钮是否吸附
    sticky?: boolean
  }
  const props = defineProps<Props>()
  const emit = defineEmits(['update:visible'])
  const { visible, title, width, columns, params, ajaxUrl } = toRefs(props) as any
  const formState = reactive({})
  /**
   * formatter格式化方法
   * @param record 当前列数据
   * @param value 值
   * @param cb  回调函数
   */
  const formatter = (record: any, value: string, cb: Function) => {
    if (typeof cb === 'function') {
      return cb(formState, formState[value])
    }
  }

  /**
   * customRender 支持传入DOM结构元素渲染
   * @param cb 自定义渲染回调函数传回的tsx结构元素内容
   */
  const customRender = (cb: Function, value: string) => {
    const element = document.getElementsByClassName(`rendSlot-${value}`)[0] as HTMLElement
    if (element && typeof cb === 'function') {
      render(cb(formState[value]), element)
    }
  }
  /**
   * formatterShow 控制判断是否展示或隐藏（条件渲染）
   * @param val boolean值或者动态渲染回调函数
   */
  const formatterShow = (val: boolean | Function) => {
    if (typeof val === 'function') {
      return val(formState)
    }
    return val
  }
  /**
   * 通知关闭弹窗
   */
  const cancel = () => {
    Object.keys(formState).forEach((key) => {
      delete formState[key]
    })
    emit('update:visible', false)
  }

  const getDetail = async () => {
    const res = await ajaxUrl.value(params.value)
    Object.assign(formState, res.data)
  }

  watch(
    () => props.visible,
    () => {
      if (props.visible) {
        getDetail()
      }
    }
  )
</script>
<style lang="less" scoped>
  :global(.ant-drawer-title) {
    font-size: 20px !important;
    font-weight: 600 !important;
  }

  p {
    margin-bottom: 0;
  }

  :deep(.ant-form-item-label) {
    padding-bottom: 10px;
  }

  .photo-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    &-item {
      display: flex;
    }

    :deep(.ant-image) {
      width: 100%;
      margin-top: 10px;
      margin-inline-end: 5px;
    }

    :deep(.ant-image-img) {
      width: 50px;
      height: 50px;
      border-radius: 6px;
      margin-top: 10px;
    }
  }
</style>
